import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, Share2Icon } from 'lucide-react';
import { SHARE_URL } from '../data/proposal';
const EASE = [0.23, 1, 0.32, 1] as const;

/** Secondary action: copies the public Snak link so it can be passed to a colleague. */
export function ShareLink() {
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (!copied) return;
    const t = window.setTimeout(() => setCopied(false), 2000);
    return () => window.clearTimeout(t);
  }, [copied]);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(SHARE_URL);
    } catch {
      // Fallback for browsers or frames without clipboard permission.
      const field = document.createElement('textarea');
      field.value = SHARE_URL;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      document.execCommand('copy');
      document.body.removeChild(field);
    }
    setCopied(true);
  };
  return <button type="button" onClick={copy} aria-label={copied ? 'Link copied' : `Share with a colleague — copy ${SHARE_URL}`} className="mt-2 inline-flex h-6 items-center gap-1.5 rounded-full text-[12.5px] font-medium text-navy transition-colors duration-150 hover:text-teal focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-navy" data-id="element-666" data-mp="3hjlqk0vd8syd">
      <AnimatePresence mode="wait" initial={false} data-id="element-667" data-mp="42w6xaoibzcy">
        <motion.span key={copied ? 'done' : 'share'} className="inline-flex items-center gap-1.5" initial={{
        opacity: 0,
        y: 2
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.15,
        ease: EASE
      }} data-id="element-668" data-mp="i2x5ukl7owps">
          {copied ? <>
              <CheckIcon size={13} strokeWidth={2.25} className="text-teal" aria-hidden="true" data-id="element-669" data-mp="2ewqwi9qhertw" />
              Link copied
            </> : <>
              Share with a colleague
              <Share2Icon size={13} strokeWidth={2} aria-hidden="true" data-id="element-670" data-mp="nrxgvad88w4q" />
            </>}
        </motion.span>
      </AnimatePresence>
      <span className="sr-only" aria-live="polite" data-id="element-671" data-mp="ws3seqpd7m19">
        {copied ? 'Link copied to clipboard' : ''}
      </span>
    </button>;
}